module.exports = __webpack_public_path__ + "static/img/blackCatLogo.25eccdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blackCatLogo.png
// module id = b0Eq
// module chunks = 118